<div class="dialog-modal">
  <div class="dialog-modal-body">
    <div class="row mt-3">
      <div class="col-12 col-xl mb-3">
        <div class="card">
          <div class="card-body">
            <div class="row justify-content-center">
              <div class="col-md-12">
                <div class="tisco-main-form">
                  <div class="text-center">
                    <div>
                      <div class="form-control text-bold" style="font-size: 1.7rem;">{{title}}</div>
                    </div>
                  </div>
                  <div class="text-center mt-2">
                    <div>
                      <div class="form-control text-bold">{{description}}</div>
                    </div>
                  </div>
                  <div class="text-center mt-4">
                    <div *ngIf="action=='alert'">
                      <button class="btn square-btn btn-primary mr-2 ml-2 mb-2" type="button"
                        (click)="onClose(true)">{{btnText}}</button>
                    </div>
                    <div *ngIf="action=='confirm'">
                      <button class="btn square-btn btn-default btn-danger mr-2 ml-2 mb-2 btn-min" type="button"
                        (click)="onClose(false)" *ngIf="action=='confirm' && btnCancel">{{btnCancel}}</button>
                      <button class="btn square-btn btn-primary mr-2 ml-2 mb-2 btn-min" type="button"
                        (click)="onClose(true)">{{btnConfirm}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>